<div class="p-invalid-from-message">
  <span><i [ngClass]="['pi ' + icon]"></i></span>
  <small id="username-help" class="p-error">Se debe cargar al menos un archivo para este examen</small>
</div>
